import { createContext, ReactNode, useContext } from 'react';
import { PaginationContextType, usePagination } from '../search-windows/use-pagination';

const PaginationContext = createContext<PaginationContextType | undefined>(undefined);

export function useUnitStatusSearchResultsPaginationContext() {
    const context = useContext(PaginationContext);
    if (context === undefined) {
        throw new Error(
            'useUnitStatusSearchResultsPaginationContext must be used within a UnitStatusSearchResultsPaginationProvider'
        );
    }
    return context;
}

export const UnitStatusSearchResultsPaginationProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const pagination = usePagination();
    return <PaginationContext.Provider value={pagination}>{children}</PaginationContext.Provider>;
};
